import { MonthlySheetStatus } from 'pages/Tasks/MonthlySheet/types'
import { EventsOfTask } from 'pages/Tasks/types'
import type { Action } from 'redesign/components/organisms/action-wrapper/types'
import { BUTTON_TYPE } from 'redesign/components/templates/task-details-action-buttons/constant'
import type { ResolveActionButtonsProps } from 'redesign/components/templates/task-details-action-buttons/types'
import { getAcceptButton } from './get-accept-button'
import { getClaimButton } from './get-claim-button'

export const getTodoStateButtons = (props: ResolveActionButtonsProps): Action[] => {
  const { sendEvent, refetch, t, task, prevMonthTask, handleButtonAction } = props

  const showClaimButton = task.status !== MonthlySheetStatus.markedChangeNextMonth && Boolean(task.timeline?.length)

  const acceptAction = () => {
    if (prevMonthTask) {
      handleButtonAction(BUTTON_TYPE.acceptMultipleMonths)

      return
    }

    sendEvent(EventsOfTask.monthlySheetAccept, undefined, refetch)
  }

  return [
    getAcceptButton({
      sendEvent,
      refetch,
      t,
      buttonProps: { onClick: acceptAction },
    }),
    ...(showClaimButton ? [getClaimButton(props)] : []),
  ]
}
